import { SunburstChart } from '@/common/dashboard/charts/SunburstChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const AbvSapReconDiscrepancyDriversChart = ({ prodIds, channelIds, trxGrp }) => {
  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    const reqParam = { prodIds, channelIds, trxGrp };
    rsrc.data('gtn', 'RECON_DISCREPANCY_DRIVERS_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });
  }, [prodIds, channelIds]);

  if (!data) return null;

  return (
    <SunburstChart data={data} />
  )

};
